import type { ReactNode } from 'react';

import type { TEmailCaptureElement } from '@shared/dream-components';
import { EmailCaptureElement } from '@shared/dream-components';

interface Props {
  node: TEmailCaptureElement;
  children: ReactNode | ReactNode[];
}

const EmailCapture = ({ node, children }: Props) => {
  return (
    <EmailCaptureElement element={node} isLive>
      {children}
    </EmailCaptureElement>
  );
};

export default EmailCapture;
